import { render, staticRenderFns } from "./Compartido.vue?vue&type=template&id=1d911096&"
import script from "./Compartido.vue?vue&type=script&lang=js&"
export * from "./Compartido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports